import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { DBCheckBoxObjective } from '_components';
import styles from './Common.module.css';

class SpecTestsBehavior extends React.Component {

    renderRow(col1label, col1, col2label, col2) {
        return (
            <div className={styles.checkbox_row}>
                <span className={styles.flag} />
                <span className={styles.spacer} />
                <span className={styles.label} />
                <DBCheckBoxObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    field={col1}
                    label={col1label}
                    className={styles.checkbox}
                />
                <DBCheckBoxObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    field={col2}
                    label={col2label}
                    className={styles.checkbox}
                />
            </div>
        );
    }


    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_Behavior' name='Behavior' visible={false} flagged={this.props.flagged} mopno={this.props.panels[0].MOPNO}>
                    {this.renderRow('Combative', 'TSBEHCOMBATIVE', 'Motivated', 'TSBEHMOTIVATED')}
                    {this.renderRow('Agitated', 'TSBEHAGITATED', 'Impulsive', 'TSBEHIMPULSIVE')}
                    {this.renderRow('Aggressive', 'TSBEHAGGRESSIVE', 'Distracted', 'TSBEHDISTRACTED')}
                    {this.renderRow('Depressed', 'TSBEHDEPRESSED', 'Delayed', 'TSBEHDELAYED')}
                    {this.renderRow('Confused', 'TSBEHCONFUSED', 'Attentive', 'TSBEHATTENTIVE')}
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));


    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'Behavior'),
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHCOMBATIVE ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHAGITATED ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHAGGRESSIVE ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHDEPRESSED ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHCONFUSED ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHMOTIVATED ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHIMPULSIVE ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHDISTRACTED ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHDELAYED ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBEHATTENTIVE
            ? true : false

    };
}

const connectedSpecTestsBehavior = connect(mapStateToProps)(SpecTestsBehavior);
export { connectedSpecTestsBehavior as SpecTestsBehavior };


